<template>
  <div class="form-warp">
    <div class="container">
      <van-form validate-first scroll-to-error @submit="onSubmit" @failed="onFailed">
        <div class="form-box">
          <div class="form-cell">
            <div class="form-title">公司名<sup>*</sup></div>
            <div class="form-input form-input-block">
              <van-field
                v-model="company"
                name="company"
                placeholder="请输入您的公司名称"
                :rules="[{ required: true, message: '请输入您的公司名称 ' }]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">产品类型<sup>*</sup></div>
            <div class="form-input form-input-block">
              <van-field
                v-model="productType"
                name="productType"
                placeholder="请输入产品类型"
                :rules="[{ required: true, message: '请输入产品类型' }]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">用途<sup>*</sup></div>
            <div class="form-input form-input-block">
              <van-field
                v-model="productUse"
                name="productUse"
                placeholder="请输入产品用途"
                :rules="[{ required: true, message: '请输入产品用途' }]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">
              姓名
              <sup>*</sup>
            </div>
            <div class="form-input form-input-block">
              <van-field
                v-model="name"
                name="name"
                placeholder="请输入您的姓名"
                :rules="[{ required: true, message: '请输入您的姓名' }]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">联系电话<sup>*</sup></div>
            <div class="form-input form-input-block">
              <van-field
                v-model="tel"
                name="tel"
                placeholder="请输入您的联系电话"
                :rules="[
                  {
                    pattern: /^(1)\d{10}$/,
                    message: '请填写正确的手机号',
                  },
                ]"
              />
            </div>
          </div>
          <div class="form-cell">
            <div class="form-title">电子邮箱<sup>*</sup></div>
            <div class="form-input form-input-block">
              <van-field
                v-model="email"
                name="email"
                placeholder="请输入您的电子邮箱"
                :rules="[
                  {
                    required: true,
                    pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                    message: '请输入正确的邮箱',
                  },
                ]"
              />
            </div>
          </div>
        </div>
        <div class="form-btn-cell">
          <van-button
            type="primary"
            :loading="btnLoading"
            loading-text="加载中..."
            :disabled="btnLoading"
            native-type="submit"
            block
            >发送需求</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import api from "@/components/axios";
import { Toast } from "vant";

export default {
  components: {},
  data() {
    return {
      company: "",
      productType: "",
      productUse: "",
      name: "",
      tel: "",
      email: "",
      btnLoading: false,
    };
  },
  methods: {
    onSubmit() {
      this.btnLoading = true;
      let data = {
        companyName: this.company,
        productType: this.productType,
        use: this.productUse,
        name: this.name,
        phone: this.tel,
        email: this.email,
      };
      api
        .post("/customized_needs", data)
        .then((res) => {
          console.log(res);
          if (res.data.code === 200) {
            this.$toast.success("提交成功");
            this.$router.push("/trial-result");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {
          this.btnLoading = false;
        });
    },
    onFailed(values) {
      console.log("onFailed", values);
      Toast.fail(values.errors[0].message);
    },
  },
};
</script>

<style lang="less">
.form-btn-cell {
  .van-loading__circular {
    display: block;
  }
}
</style>
